// extracted by mini-css-extract-plugin
export var active = "_fd-7";
export var blink = "_fd-8";
export var dropDownSelector = "_fd-4";
export var dropDownWrapper = "_fd-3";
export var fakeCursor = "_fd-6";
export var fontSizeButton = "_fd-9";
export var formQuillEditor = "_fd-0";
export var pressed = "_fd-a";
export var qlBlank = "_fd-1";
export var textFormattingToolbar = "_fd-2";
export var textToolbarOption = "_fd-5";